import { useCurrentUser } from '@zealth/core/firebase/authStore'
import { useEffect } from 'react'

import { applySupportWidgetVisibility } from '@/features/analytics'

// PostHog's conversations widget loads asynchronously after init and
// auto-renders when enabled, so a single call on mount can run before the
// module is ready (and get ignored). Retry on a short interval until the
// visibility sticks, then stop — bounded by a give-up timeout so an
// unavailable widget (e.g. disabled in the project) never polls forever.
const RETRY_INTERVAL_MS = 300
const GIVE_UP_AFTER_MS = 10_000

// Gates the PostHog support chat widget on auth state: hidden for anonymous
// visitors, shown once the user is signed in. Mount once near the app root.
export function useSupportWidget(): void {
  const isLoggedIn = !!useCurrentUser()

  useEffect(() => {
    if (applySupportWidgetVisibility(isLoggedIn)) return

    const interval = setInterval(() => {
      if (applySupportWidgetVisibility(isLoggedIn)) clearInterval(interval)
    }, RETRY_INTERVAL_MS)
    const giveUp = setTimeout(() => clearInterval(interval), GIVE_UP_AFTER_MS)

    return (): void => {
      clearInterval(interval)
      clearTimeout(giveUp)
    }
  }, [isLoggedIn])
}
